<template>
  <div class="feedback">
    <!-- 内容 start-->
    <div class="wrap" v-if="notFinish">
      <div class="container">
        <div class="breadcrumb">
          <a href="https://online.xueersi.com" class="breadcrumb__index">选课中心</a>
          <span class="breadcrumb__courseCenter">意见反馈</span>
        </div>
        <div class="feedback-body">
          <!-- 反馈表单-->
          <div class="form-feedback" id="form-feedback" enctype="multipart/form-data">
            <div class="f-item">
              <h1><em>*</em>请选择问题发生的场景</h1>
              <ul class="f-list f-first">
                <li
                  v-for="(item, index) in scene"
                  :key="index"
                  :class="{ active: item.id === currentScene }"
                  @click="changeScene(item)"
                >
                  {{ item.text }}
                </li>
              </ul>
            </div>
            <div class="f-item style" v-if="problemType && problemType.length > 0">
              <h1><em>*</em>请选择问题类型</h1>
              <input type="hidden" />
              <ul class="f-list f-second">
                <li
                  v-for="(item, index) in problemType"
                  :key="index"
                  :class="{ active: item.id === currentType }"
                  @click="currentType = item.id"
                >
                  {{ item.content }}
                </li>
              </ul>
            </div>
            <div class="f-item">
              <h1><em>*</em>请描述你的问题（5～500字）</h1>
              <div class="f-text">
                <textarea
                  name=""
                  id="text_textarea"
                  cols="64"
                  rows="8"
                  placeholder="请将你的建议或遇到的问题详细地告诉我们"
                  v-model="problemText"
                  @keyup="textInput()"
                ></textarea>
                <p class="text__count">
                  <span id="text_a">{{ textNumber }}</span
                  >/<span id="text_b">500</span>
                </p>
              </div>
            </div>
            <div class="f-item">
              <h1 class="three">请上传图片（最多5张）</h1>
              <div class="input-file-item" id="input-file-item" v-if="showInputImg">
                <span class="input-file-bg"></span>
                <input
                  @change="getFullPathFeed($event)"
                  ref="feedbackImg"
                  type="file"
                  :value="imgValue"
                  class="input-file"
                  autocomplete="off"
                />
              </div>
              <div id="gImgs" ref="gImgs">
                <template v-if="imgInfo && imgInfo.length > 0">
                  <div class="gImgs__item" v-for="(item, index) in imgInfo" :key="index">
                    <i class="gImgs__item__close" @click="closeFeedbackImg(index)"></i>
                    <img :src="item.imgurl" />
                  </div>
                </template>
              </div>
            </div>
            <div class="f-item">
              <h1><em>*</em>请留下你的手机号码，以便我们及时回复</h1>
              <div class="f-phone">
                <input
                  type="text"
                  v-model="phoneNumber"
                  id="fPhone"
                  name="fPhone"
                  class="phone"
                  placeholder=""
                  maxlength="11"
                />
              </div>
            </div>
            <div class="f-item">
              <div class="btnSubmit"><button @click="submit">提交</button></div>
            </div>
          </div>
          <!-- 反馈表单完成-->
        </div>
      </div>
    </div>
    <div class="wrap" v-else>
      <div class="feedback-success">
        <div class="feedback-body">
          <div class="feedback-finish">
            <img src="https://res14.xesimg.com/www/img/aidou-pic.png" alt="" />
            <div class="t-finish-title">反馈成功，感谢您的宝贵意见！</div>
            <div class="t-finish-tips">
              <em>{{ finishTime }}</em
              >秒后自动跳转回首页<a href="//online.xueersi.com/"
                >若不能自动跳转，请点击这里</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { Feedback } from '@/networks/api'
import titleMixin from '@/util/title'
export default {
  mixins: [titleMixin],
  title() {
    return '意见反馈'
  },
  data() {
    return {
      scene: [
        {
          id: 101,
          text: '讲义邮寄问题'
        },
        {
          id: 102,
          text: '课程更换及费用'
        },
        {
          id: 103,
          text: '联系班主任'
        },
        {
          id: 104,
          text: '修改学员资料及其他'
        }
      ],
      handouts: [
        {
          id: 15,
          content: '未收到讲义'
        },
        {
          id: 16,
          content: '修改寄送地址'
        },
        {
          id: 17,
          content: '讲义质量问题'
        }
      ],
      salesProblem: [
        {
          id: 18,
          content: '退课'
        },
        {
          id: 19,
          content: '调课'
        },
        {
          id: 20,
          content: '退费'
        }
      ],
      contactTeach: [
        {
          id: 29,
          content: '修改学员资料'
        },
        {
          id: 30,
          content: '其他咨询建议'
        }
      ],
      currentScene: 101,
      currentSceneText: '讲义邮寄问题',
      currentType: null,
      problemType: [],
      problemText: '',
      textNumber: 0,
      imgInfo: [],
      imgValue: '',
      showInputImg: true,
      phoneNumber: '',
      notFinish: true,
      finishTime: 5
    }
  },
  mounted() {
    this.problemType = this.handouts
  },
  methods: {
    changeScene(item) {
      this.currentScene = item.id
      this.currentSceneText = item.text
      this.currentType = null
      switch (item.id) {
        case 101:
          this.problemType = this.handouts
          break
        case 102:
          this.problemType = this.salesProblem
          break
        case 103:
          this.problemType = null
          break
        case 104:
          this.problemType = this.contactTeach
          break
        default:
          this.problemType = this.handouts
      }
    },
    textInput() {
      let len = this.problemText.trim().length
      if (len > 499) {
        this.problemText.trim().substring(0, 500)
        this.textNumber = this.problemText.trim().length
      } else {
        this.textNumber = this.problemText.trim().length
      }
    },
    getFullPathFeed(e) {
      const obj = e.target
      if (obj) {
        this.setImg(obj)
      }
    },
    setImg(obj) {
      const strSrc = obj.value
      const url = window.URL.createObjectURL(obj.files.item(0))
      const pos = strSrc.lastIndexOf('.')
      const lastname = strSrc.substring(pos, strSrc.length)
      if (
        lastname.toLowerCase() !== '.jpg' &&
        lastname.toLowerCase() !== '.gif' &&
        lastname.toLowerCase() !== '.png' &&
        lastname.toLowerCase() !== '.jpeg'
      ) {
        this.imgValue = ''
        window.alert(`您选择的文件类型为${lastname}，图片必须为 JPG,GIF,PNG 类型`)
        return false
      }
      if (this.imgInfo && this.imgInfo.length < 5) {
        this.imgInfo.push({
          imgurl: url,
          file: obj.files[0]
        })
      }
      if (this.imgInfo && this.imgInfo.length === 5) this.showInputImg = false
    },
    closeFeedbackImg(index) {
      this.imgInfo.splice(index, 1)
      if (this.imgInfo && this.imgInfo.length < 5) this.showInputImg = true
    },
    async submit() {
      if (!this.currentType && this.currentScene !== 103) {
        window.alert('请选择问题类型!')
        return false
      }
      if (this.problemText.length < 5) {
        window.alert('内容至少五个字！')
        return false
      }
      if (!this.phoneNumber) {
        window.alert('请输入手机号！')
        return false
      }
      if (!/^1\d{10}$/.test(this.phoneNumber)) {
        window.alert('请填写正确的手机号')
        return false
      }
      // eslint-disable-next-line no-undef
      let params = new FormData()
      this.imgInfo.forEach((item, index) => {
        params.append(index, item.file)
      })
      params.append('phone', this.phoneNumber)
      params.append('type_id', this.currentScene)
      params.append('label_ids', this.currentType)
      params.append('type_name', this.currentSceneText)
      params.append('content', this.problemText)
      params.append('source', 1)
      if (Cookies.get('stu_id')) {
        params.append('stu_id', Number(Cookies.get('stu_id')))
      }
      const { data } = await Feedback.submitFeed(params)
      if (Number(data.stat) === 1) {
        this.notFinish = false
        window.scrollTo(0, 0)
        this.feedbackTimes()
      } else {
        window.alert(data.msg)
      }
    },
    feedbackTimes() {
      let timer = setInterval(() => {
        this.finishTime--
        if (this.finishTime === 0) {
          clearInterval(timer)
          this.$router.push({ path: '/' })
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.container {
  width: 1200px !important;
  margin: 0 auto;
  padding: 0;
}
.feedback-success {
  min-height: 1000px;
  background: #fff;
}
.form-feedback {
  margin-top: 40px;
  margin-left: 60px;
}

.feedback-body {
  background: #fff;
  overflow: hidden;
  margin-bottom: 20px;
}

.feedback-body .f-item {
  overflow: hidden;
  margin-bottom: 40px;
}

.feedback-body .f-item h1 {
  font-size: 14px;
  font-weight: normal;
  color: #333333;
  margin: 0;
}

.feedback-body .f-item h1 em {
  color: #ff3334;
  margin-right: 5px;
  vertical-align: middle;
}

.feedback-body .f-item h1.three {
  margin-top: 0;
}

.feedback-body .f-item ul.f-list {
  overflow: hidden;
  margin-top: 20px;
  /* padding-left: 12px; */
}

.feedback-body .f-item ul.f-list li {
  float: left;
  border: 1px solid #dcdcdc;
  text-align: center;
  font-size: 14px;
  color: #666666;
  margin-right: 20px;
  border-radius: 2px;
  cursor: pointer;
  padding: 10px 18px;
}

.feedback-body .f-item ul.f-list li.active {
  border: 1px solid #ff3334;
  color: #ff3334;
}

.feedback-body .f-item .f-text {
  overflow: hidden;
  margin-top: 20px;
}

.feedback-body .f-item .f-text textarea {
  width: 940px;
  height: 180px;
  border: 1px solid #dcdcdc;
  border-radius: 2px;
  padding: 10px;
  color: #666;
  font-size: 14px;
  font-weight: normal;
}

.feedback-body .f-item .f-text .text__count {
  color: #999;
  margin: 0;
  padding: 0;
  margin-left: 900px;
  padding-top: 10px;
  position: absolute;
}

.feedback-body .f-item .f-phone {
  font-size: 14px;
  margin-top: 20px;
}

.feedback-body .f-item .f-phone .phone {
  width: 300px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #dcdcdc;
  border-radius: 2px;
  padding-left: 5px;
  color: #999;
}

.feedback-body .f-item .input-file-item {
  float: left;
  overflow: hidden;
  margin-top: 20px;
  position: relative;
  margin-right: 20px;
}

.feedback-body .f-item .input-file-item .input-file-bg {
  display: block;
  width: 140px;
  height: 140px;
  background: url(./img/addPic.png) no-repeat left 50% top 50%;
  background-size: 47px 47px;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
}

.feedback-body .f-item .input-file-item .input-file {
  width: 140px;
  height: 140px;
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 10;
  cursor: pointer;
}

.feedback-body .f-item #gImgs .gImgs__item {
  float: left;
  width: 140px;
  height: 140px;
  border: 1px solid #dcdcdc;
  margin-top: 20px;
  margin-right: 20px;
  position: relative;
  border-radius: 3px;
}

.feedback-body .f-item #gImgs .gImgs__item img {
  width: 138px;
  height: 138px;
  border-radius: 2px;
}

.feedback-body .f-item #gImgs .gImgs__item__close {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  background-image: url(./img/feedback-close.png);
  background-size: 20px 20px;
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  cursor: pointer;
}

.feedback-body .f-item .btnSubmit {
  overflow: hidden;
}

.feedback-body .f-item .btnSubmit button {
  width: 120px;
  height: 36px;
  line-height: 36px;
  border-radius: 2px;
  background: #f00;
  color: #fff;
  font-size: 14px;
  text-align: center;
  border: 0;
}

.feedback-body .f-item .timesOne {
  color: #999;
  line-height: 80px;
  padding-left: 12px;
}

.feedback-body .feedback-finish {
  text-align: center;
  padding: 50px 0 20px;
}

.feedback-body .feedback-finish .t-finish-title {
  line-height: 70px;
  font-size: 16px;
  color: #ff3334;
}

.feedback-body .feedback-finish .t-finish-tips {
  font-size: 14px;
  color: #999;
  padding-top: 20px;
}

.feedback-body .feedback-finish .t-finish-tips a {
  color: #1e89e0;
  padding-left: 10px;
}

.feedback-body .feedback-finish .t-finish-tips em {
  color: #ff3334;
  margin-right: 5px;
}

.breadcrumb {
  padding: 15px 0;
  font-size: 12px;
  margin-bottom: 0px;
}
.breadcrumb .breadcrumb__index {
  color: #999;
}
.breadcrumb .breadcrumb__index .breadcrumb__courseCenter {
  color: #333;
}
.breadcrumb .breadcrumb__courseCenter:before {
  content: '>';
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/Feedback/index.vue